var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#alert_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 28.417c7.134 0 12.917-5.783 12.917-12.917 0-7.134-5.783-12.916-12.917-12.916-7.134 0-12.916 5.782-12.916 12.916S8.366 28.417 15.5 28.417Z",
    fill: "#FAFAFA",
    stroke: "#EE2A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10.334V15.5",
    stroke: "#EE2A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 20.959,
    fill: "#EE2A2A",
    r: 1.292
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "alert_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h31v31H0z"
  })))));
};
export default SvgAlert;